// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"3ee12b63","220":"1078a760","264":"e1b4f314","331":"05e75a50","428":"6e97b1f6","485":"a3340e1e","549":"60bfc220","601":"17f9c828","774":"c2f5144f","808":"6629480d","884":"3a108d39","886":"53c333bd","962":"b690df90"}[chunkId] + ".chunk.js";
};